/**
 * @summary 獲取當前頁面的語系
 * @param domain 要送出的網域名
 * @returns 目前頁面指定的語系代號
 */
import { useEffect, useState } from "react";

interface ILanguage {
    currentCurrency: string; // 當前幣別
    currentLanguage: string; // 當前語系
}

const useLang = (domain: string) => {
    const [lanObj, setLanObj] = useState<ILanguage>({
        currentCurrency: 'TWD',  // 預設新台幣
        currentLanguage: 'zh-tw' // 預設中文語系
    })
    useEffect(() => {   
        const fetchHandler = async () => {
            try {
                const source = domain + 'common/getlanguage';
                const response = await fetch(source);

                if (!response.ok) {
                    throw new Error(`${response.status} / ${response.statusText}`);
                }

                const data: ILanguage = await response.json();

                if (data?.currentLanguage && data?.currentCurrency) {
                    setLanObj(data)
                }
            } catch (error) {
                console.error('fetch getlanguage Error:', error);
            }
        };

        fetchHandler();
    }, [domain])
    return lanObj;
};

export default useLang;